import { Link } from "react-router";
import { Icon } from "../../../components/Icon";
import { useArbeitsbereich } from "../../../components/Tarif";
import { KopfMehr } from "../../../components/ui";
import { t } from "../../../lib/sprache";
import { VOREINSTELLUNGEN, type ListenModul } from "./baum";
import "./einstellungen-vollbild.css";

/**
 * IA-1 Schritt 3 (Zoho-Vorbild „⋯ → Voreinstellungen“): Eintrag im Menü „Mehr“ einer Liste, der direkt zu den Einstellungen
 * dieses Moduls springt. Nur für den Admin (nur er bearbeitet Einstellungen); für alle anderen fehlt der Eintrag ganz.
 */
export function VoreinstellungenEintrag({ modul }: { modul: ListenModul }) {
  const ws = useArbeitsbereich();
  if (!ws?.isChef) return null;
  return (
    <Link className="tk-voreinstellungen" to={VOREINSTELLUNGEN[modul]}>
      <Icon name="settings" />{t("Voreinstellungen", "Preferences")}
    </Link>
  );
}

/** Für Listen ohne eigenes Menü „Mehr“: das Menü nur mit „Voreinstellungen“ (für Nicht-Admins gar nicht). */
export function ListenVoreinstellungen({ modul }: { modul: ListenModul }) {
  const ws = useArbeitsbereich();
  if (!ws?.isChef) return null;
  return <KopfMehr><VoreinstellungenEintrag modul={modul} /></KopfMehr>;
}
